const GLOBAL_ERROR_PREFIX = 'Wystąpił błąd, prześlij zdjęcie tego komunikatu do wsparcia technicznego:';

const addUniquePart = (parts, value) => {
  const text = String(value || '').trim();
  if (text && !parts.includes(text)) parts.push(text);
};

const formatError = (error) => {
  const parts = [];
  addUniquePart(parts, error?.message);
  addUniquePart(parts, error?.stack);
  return parts.join('\n\n');
};

const hasStackTrace = (value) => {
  if (!value) return false;
  if (value instanceof Error) return Boolean(String(value.stack || '').trim());
  if (typeof value !== 'object') return false;
  if (String(value.stack || '').trim()) return true;
  return hasStackTrace(value.error) || hasStackTrace(value.reason);
};

export const formatGlobalErrorMessage = (value) => {
  if (value instanceof Error) {
    const message = formatError(value);
    return message || 'Nieznany błąd.';
  }

  if (value && typeof value === 'object') {
    const parts = [];
    addUniquePart(parts, value.message);

    if (value.error instanceof Error) addUniquePart(parts, formatError(value.error));
    else if (value.error) addUniquePart(parts, formatGlobalErrorMessage(value.error));

    if (value.reason instanceof Error) addUniquePart(parts, formatError(value.reason));
    else if (value.reason) addUniquePart(parts, formatGlobalErrorMessage(value.reason));

    addUniquePart(parts, value.stack);

    if (parts.length > 0) return parts.join('\n\n');
  }

  const message = String(value || '').trim();
  return message || 'Nieznany błąd.';
};

export const buildGlobalErrorAlertMessage = (value) =>
  `${GLOBAL_ERROR_PREFIX} ${formatGlobalErrorMessage(value)}`;

export function installGlobalErrorAlert({ target = window, alertFn = window.alert } = {}) {
  if (!target || typeof target.addEventListener !== 'function') return () => {};

  const showError = (value) => {
    if (typeof alertFn === 'function') {
      alertFn(buildGlobalErrorAlertMessage(value));
    }
  };

  const onError = (event) => {
    if (!hasStackTrace(event)) return;
    showError(event);
  };

  const onUnhandledRejection = (event) => {
    if (!hasStackTrace(event)) return;
    showError(event);
  };

  target.addEventListener('error', onError);
  target.addEventListener('unhandledrejection', onUnhandledRejection);

  return () => {
    target.removeEventListener?.('error', onError);
    target.removeEventListener?.('unhandledrejection', onUnhandledRejection);
  };
}
